import { userStatusSchema, userTypeSchema } from '@pm-tool/shared';
import { createFileRoute } from '@tanstack/react-router';
import { useCallback } from 'react';
import { z } from 'zod';
import type { UserFilters } from '@/features/admin/admin-api';
import { requirePermission } from '@/features/admin/guard';
import { UserList } from '@/features/admin/users/user-list';

/** Filters live in the URL so lists can be shared and survive reloads. */
const searchSchema = z.object({
  q: z.string().optional().catch(undefined),
  type: userTypeSchema.optional().catch(undefined),
  status: userStatusSchema.optional().catch(undefined),
  organizationId: z.uuid().optional().catch(undefined),
});

export const Route = createFileRoute('/_app/admin/users/')({
  validateSearch: searchSchema,
  beforeLoad: ({ context }) => {
    requirePermission(context.me, 'admin.users');
  },
  component: UsersPage,
});

function UsersPage() {
  const filters = Route.useSearch();
  const navigate = Route.useNavigate();
  const onFiltersChange = useCallback(
    (next: UserFilters) => {
      void navigate({ search: next, replace: true });
    },
    [navigate],
  );
  return <UserList filters={filters} onFiltersChange={onFiltersChange} />;
}
